import { TEST_LOCATORS } from '@src/constants/test-locators'
import ContentfulInternationalSizeConversionGuide from '@src/quince-site-common/src/domains/contentful/contentful-international-size-conversion-guide'
import {
  ContentfulSizeChart,
  ContentfulSizeChartSection,
} from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

import { ProductSizeGuide } from '../sizeGuide/SizeGuide.types'

import SizeChartContent from './components/SizeChartContent.component'
import styles from './sizeChart.module.scss'

interface SizeChartProps {
  className?: string
  activeSizeGuideUnitIndex: number
  productSizeGuides?: ProductSizeGuide[]
  sizeChart: ContentfulSizeChart | ContentfulInternationalSizeConversionGuide | undefined
}

const SizeChart = (props: SizeChartProps) => {
  const sizeChartSections: ContentfulSizeChartSection[] = props.sizeChart?.sections || []
  const activeSizeChartSection = sizeChartSections[props.activeSizeGuideUnitIndex]

  return (
    <div className={styles.container} data-testid={TEST_LOCATORS.SIZE_CHART}>
      <SizeChartContent sizeChartSection={activeSizeChartSection} />
    </div>
  )
}

export default SizeChart
